// 描画情報クラス
import { CanvasItemData } from '@/js/CanvasItemData.js'
import { OffScreen } from '@/js/OffScreen.js'
import { CreateImageElement, CreateTextImage, RotateImage, CreateQRImage } from '@/js/CommonFunc.js'


//import { BIconChevronCompactLeft } from 'bootstrap-vue';
import Vue from 'vue'

class CanvasData {
    constructor(productData, printInfo = "front", canvasSizeInfo) {
        // 背景画像データ
        this.canvasSizeInfo = canvasSizeInfo
        // 配置アイテムリスト
        this.itemList = [];
        this.productData = productData
        this.printInfo = printInfo
        this.alphaValue = 0
        this.ripuValue = 0;
        this.paintedWidth = 0
        this.paintedHeight = 0
        this.paintedPrice = 0
        this.isReady = true

        if (printInfo == "tag") {
            this.backgroundImagePath = require("@/assets/tagback.png");
            this.backgroundImageObj = new Image();
            this.backgroundImageObj.crossOrigin = 'Anonymous';
            this.backgroundImageObj.src = this.backgroundImagePath;
            //this.cutlineImagePath = "";
            this.foregroundImagePath = ""
            this.canvasSize = { width: 1000, height: 1500 };
            this.canvasScreenSize = { width: 467, height: 700 };
            this.canvasScreenPosition = { x: 126, y: 0 };
            this.canvasMiriMeterSize = { width: 200, height: 300 }
            this.ripuValue = 0;
        } else {
            //this.setBackForegroundImage()

            this.canvasSize = { width: canvasSizeInfo.width, height: canvasSizeInfo.height };
            this.canvasScreenSize = { width: canvasSizeInfo.canvasScreenSizeWidth, height: canvasSizeInfo.canvasScreenSizeHeight };
            this.canvasScreenPosition = { x: canvasSizeInfo.canvasScreenPositionX, y: canvasSizeInfo.canvasScreenPositionY };
            this.canvasMiriMeterSize = { width: canvasSizeInfo.canvasMiriMeterSizeWidth, height: canvasSizeInfo.canvasMiriMeterSizeHeight }
        }
    }
    async copy(productData){
        let cvs = new CanvasData(productData,this.printInfo,this.canvasSizeInfo)
        
        for(let d of this.itemList){
            cvs.itemList.push(await d.copy(cvs))
        }
        return cvs
    }

    // デザインのベースとなる画像を登録する
    // これらの画像は編集・アップロード等に使用するので必ず呼ぶこと
    async setBaseImage( designImageFile, designImageURL, cutlineImageFile, frameCutlineImageURL ){
        this.designImageFile = designImageFile;     // オリジナルのデザイン画像
        this.cutlineImageFile = cutlineImageFile;   // オリジナルのカットライン画像
        this.designImagePath = designImageURL;      // 表示用のデザイン画像のURL
        this.cutlineDisplayImagePath = frameCutlineImageURL;    // 表示用のカットライン画像のURL
        const results = [];

        // デザイン画像
        results.push( new Promise((resolve) => {
            const img = new Image();
            this.designImageObj = img;
            this.designImageObj.crossOrigin = 'Anonymous';
            img.src = this.designImagePath;
            img.onload = function(){ resolve(); }
        }));

        // カットライン画像
        results.push( new Promise((resolve) => {
            const img = new Image();
            this.cutlineImageObj = img;
            this.cutlineImageObj.crossOrigin = 'Anonymous';
            img.src = this.cutlineDisplayImagePath;
            img.onload = function(){ resolve(); }
        }));

        await Promise.all(results);
    }

    async setDesignImage( file, url ){
        console.log("setDesignImage");
        console.log(url);
        this.designImageFile = file;
        this.designImagePath = url;
        return await new Promise((resolve) => {
            const img = new Image();
            this.designImageObj = img;
            this.designImageObj.crossOrigin = 'Anonymous';
            img.src = this.designImagePath;
            img.onload = function(){
                console.log("design img");
                console.log(img);
                resolve();
            }
        })
    }

    async setCutlineImage( file, url ){
        console.log("setCutlineImage");
        console.log(url);
        this.cutlineImageFile = file;
        this.cutlineDisplayImagePath = url;
        return await new Promise((resolve) => {
            const img = new Image();
            this.cutlineImageObj = img;
            this.cutlineImageObj.crossOrigin = 'Anonymous';
            img.src = this.cutlineDisplayImagePath;
            img.onload = function(){
                console.log("cutline img");
                console.log(img);
                resolve();
            }
        })
    }

    setBackForegroundImage() {
        /*
        
            todo:警告が出るので修正の必要あり(requireは動的にしてはいけない？)
            →フォルダまで固定の文字列で書いておくと大丈夫

        */
       console.log("gggggg");
        let path = `${this.productData.productId}_${this.productData.categoryData.classcategory_id1}_${this.productData.categoryData.classcategory_id2}_${this.printInfo}.png`

        try {
            //this.backgroundImagePath = "https://ship-resource.s3-ap-northeast-1.amazonaws.com/resource/" + path + "?rand=" + new Date().getTime()
            console.log(path);
            // this.backgroundImagePath = require("@/assets/test_data/design_1.png");
            // this.backgroundImageObj = new Image();
            // this.backgroundImageObj.crossOrigin = 'Anonymous';
            // this.backgroundImageObj.src = this.backgroundImagePath;
            // this.cutlineImagePath = require("@/assets/test_data/design_2.svg");
            this.foregroundImagePath = require("@/assets/alpha.png");
        } catch (error) {
            console.log(error)
            let path = `${this.productData.productId}_${this.productData.categoryData.classcategory_id2}_${this.printInfo}.png`
            this.backgroundImagePath = require("@/assets/" + path);
            this.backgroundImageObj = new Image();
            this.backgroundImageObj.crossOrigin = 'Anonymous';
            this.backgroundImageObj.src = this.backgroundImagePath;
            //this.cutlineImagePath = "";
            this.foregroundImagePath = require("@/assets/alpha.png");
        }

    }
    async addItem(file, info = null) {
        this.isReady = false
        if (file.type.startsWith("image/")) {
            var src = window.URL.createObjectURL(file);
        } else {
            if (this.getExt(file.name) == '') {
                return "NOEXT"
            } else {
                return 'ERROR'
            }
        }
        var img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = src;
        await this.imgload(img)
        let item = new CanvasItemData();
        item.init(file, this, img, "ImageName", "Image")
        if (info) {
            item.updatePosition(info)
        }
        this.itemList.push(item);
        Vue.set(this, "currentItem", item);

        return ''
    }
    async addTextItem(textList, font, align, color, itemName, info=null) {

        let item = new CanvasItemData();
        let fontSize = 100;
        if (info && info.fontSize) {
            fontSize = parseInt(info.fontSize);
        }
        const imageData = await CreateTextImage(textList[0], font, color, fontSize);

        var img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = URL.createObjectURL(imageData.blob);
        await this.imgload(img)

        const option = {};
        option.textList = textList;
        option.font = font;
        option.align = align;
        option.color = color;
        option.fontSize = fontSize;

        console.log(this.productData.quantity);
        item.init(imageData.blob, this, img, itemName, "Text", option, this.productData.quantity);
        console.log(item);
        if (info) {
            item.updatePosition(info);
        }
        this.itemList.push(item);
        Vue.set(this, "currentItem", item);

        return item;
    }
    async addQRItem(textList, color, bgColor, itemName, info=null) {
        let item = new CanvasItemData();
        const imageData = await CreateQRImage(textList[0], color, bgColor);
        var img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = URL.createObjectURL(imageData.blob);
        await this.imgload(img)

        const option = {};
        option.textList = textList;
        option.color = color;
        option.bgColor = bgColor;

        item.init(imageData.blob, this, img, itemName, "QR", option, this.productData.quantity);
        if (info) {
            item.updatePosition(info)
        }
        this.itemList.push(item);
        Vue.set(this, "currentItem", item);

        return item;
    }
    imgload(img) {
        return new Promise((resolve) => {
            img.onload = () => {
                resolve()
            }
        })
    }
    setCurrentItem(item) {
        Vue.set(this, "currentItem", item)
    }

    getBackgroundImagePath() {
        return this.designImagePath;
    }
    getCutlineImagePath() {
        return this.cutlineDisplayImagePath;
    }
    getForegroundImagePath() {
        return this.foregroundImagePath;
    }
    getExt(filename) {
        var pos = filename.lastIndexOf('.');
        if (pos === -1) return '';
        return filename.slice(pos + 1);
    }
    ripuUp() {
        //1ピクセルはなんミリ
        let pi = this.canvasMiriMeterSize.width / this.canvasScreenSize.width
        let move = 1.0 / pi
        this.canvasScreenPosition.y -= move
        this.ripuValue -= 1
    }
    ripuDown() {
        let pi = this.canvasMiriMeterSize.width / this.canvasScreenSize.width
        let move = 1.0 / pi
        this.canvasScreenPosition.y += move
        this.ripuValue += 1
    }
    createImage() {
        let self = this
        return new Promise((resolve) => {

            let canvasWidth = this.canvasSize.width / 10.0
            let canvasHeight = canvasWidth / this.canvasSize.width * this.canvasSize.height
            let scr = new OffScreen(canvasWidth, canvasHeight)
            this.itemList.forEach(function (item) {
                let hiritu = canvasWidth / self.canvasScreenSize.width
                let posX = ((item.posX + 10) - self.canvasScreenPosition.x) * hiritu
                let posY = ((item.posY + 10) - self.canvasScreenPosition.y) * hiritu
                let width = (item.imageWidth) * hiritu
                let height = (item.imageHeight) * hiritu
                scr.drawImage(item.imageobj, posX, posY, width, height)
            })
            let info = scr.getAlphaValue()  //paintedRectも含む
            this.alphaValue = info.alphaValue
            this.info = info
            // 描画部分の面積を求める(mm2)
            // 料金も返却
            self.paintedPrice = this.productData.caluculatePaintedAreaPrice()
            self.paintedWidth = (info.paintedRect.width * (this.canvasMiriMeterSize.width / this.canvasSize.width) * 10.0).toFixed()
            self.paintedHeight = (info.paintedRect.height * (this.canvasMiriMeterSize.height / this.canvasSize.height) * 10.0).toFixed()

            resolve({
                image: scr.canvasImage(),
                croppedImage: scr.canvasImage(),
                paintedPrice: 0,
                ripuValue: 0,
            })

            let scrImg = new Image()
            scrImg.crossOrigin = 'Anonymous'
            scrImg.src = scr.canvasImage()
            scrImg.onload = () => {

                let offs = new OffScreen(canvasWidth, info.paintedRect.height)
                offs.drawTrimmingImage(scrImg, info.paintedRect.x, info.paintedRect.y, info.paintedRect.width, info.paintedRect.height, 0, 0, info.paintedRect.width, info.paintedRect.height)
                self.ripuValue = Number((info.paintedRect.y * 10.0 * (self.canvasMiriMeterSize.width / self.canvasSize.width) / 10.0)).toFixed()
                resolve({
                    image: scr.canvasImage(),
                    croppedImage: offs.canvasImage(),
                    paintedPrice: self.paintedPrice,
                    ripuValue: self.ripuValue
                })

                // よりふちに近い画像が鏡面にあると考えて画像を書き出す
                // if (info.paintedRect.x < canvasWidth - info.paintedRect.x - info.paintedRect.width) {
                //     let offs = new OffScreen(canvasWidth - info.paintedRect.x * 2.0, info.paintedRect.height)
                //     offs.drawTrimmingImage(scrImg, info.paintedRect.x, info.paintedRect.y, info.paintedRect.width, info.paintedRect.height, 0, 0, info.paintedRect.width, info.paintedRect.height)
                //     self.ripuValue = Number((info.paintedRect.y * 10.0 * (self.canvasMiriMeterSize.width / self.canvasSize.width) / 10.0)).toFixed()
                //     resolve({
                //         image: scr.canvasImage(),
                //         croppedImage: offs.canvasImage(),
                //         paintedPrice: self.paintedPrice,
                //         ripuValue: self.ripuValue
                //     })
                // } else {
                //     let newX = (canvasWidth - (info.paintedRect.x + info.paintedRect.width))
                //     let offs = new OffScreen(canvasWidth - newX * 2.0, info.paintedRect.height)
                //     offs.drawTrimmingImage(scrImg, info.paintedRect.x, info.paintedRect.y, info.paintedRect.width, info.paintedRect.height,
                //         info.paintedRect.x - newX, 0, info.paintedRect.width, info.paintedRect.height)

                //     self.ripuValue = Number((info.paintedRect.y * 10.0 * (self.canvasMiriMeterSize.width / self.canvasSize.width) / 10.0)).toFixed()
                //     resolve({
                //         image: scr.canvasImage(),
                //         croppedImage: offs.canvasImage(),
                //         paintedPrice: self.paintedPrice,
                //         ripuValue: self.ripuValue
                //     })
                // }
            }
        })
    }
    createPreviewImage() {
        let self = this
        return new Promise((resolve) => {
            let canvasWidth = this.canvasSize.width
            let canvasHeight = canvasWidth / this.canvasSize.width * this.canvasSize.height
            let scr = new OffScreen(canvasWidth, canvasHeight)
            this.itemList.forEach(function (item) {
                let hiritu = canvasWidth / self.canvasScreenSize.width
                let posX = (item.posX + 10 - self.canvasScreenPosition.x) * hiritu
                let posY = (item.posY + 10 - self.canvasScreenPosition.y) * hiritu
                let width = item.imageWidth * hiritu
                let height = item.imageHeight * hiritu
                scr.drawImage(item.imageobj, posX, posY, width, height)
            })
            resolve(scr.canvasImage())
        })
    }

    blobImage() {
        return new Promise((resolove) => {
            let self = this
            let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
            this.itemList.forEach(function (item) {
                let hiritu = self.canvasSize.width / self.canvasScreenSize.width
                let posX = (item.posX + 10 - self.canvasScreenPosition.x) * hiritu
                let posY = (item.posY + 10 - self.canvasScreenPosition.y) * hiritu
                let width = item.imageWidth * hiritu
                let height = item.imageHeight * hiritu
                scr.drawImage(item.imageobj, posX, posY, width, height)
            })
            scr.toBlob(function (blob) {
                resolove(blob)
            })
        })
    }
    // itemを描画していく
    blobImage_2() {
        let self = this
        return new Promise((resolve) => {
            let canvasWidth = this.canvasSize.width
            let canvasHeight = canvasWidth / this.canvasSize.width * this.canvasSize.height
            let scr = new OffScreen(canvasWidth, canvasHeight)
            // デザインの描画も行う
            scr.drawImage(this.backgroundImageObj, 0, 0, canvasWidth, canvasHeight)
            this.itemList.forEach(function (item) {
                let hiritu = canvasWidth / self.canvasScreenSize.width
                let posX = (item.posX + 10 - self.canvasScreenPosition.x) * hiritu
                let posY = (item.posY + 10 - self.canvasScreenPosition.y) * hiritu
                let width = item.imageWidth * hiritu
                let height = item.imageHeight * hiritu
                scr.drawImage(item.imageobj, posX, posY, width, height)
            })
            let info = scr.getAlphaValue()  //paintedRectも含む
            this.alphaValue = info.alphaValue
            this.info = info
            // 料金も返却
            self.paintedPrice = this.productData.caluculatePaintedAreaPrice().toFixed()
            self.paintedWidth = (info.paintedRect.width * (this.canvasMiriMeterSize.width / this.canvasSize.width)).toFixed()
            self.paintedHeight = (info.paintedRect.height * (this.canvasMiriMeterSize.height / this.canvasSize.height)).toFixed()

            let scrImg = new Image()
            scrImg.crossOrigin = 'Anonymous'
            scrImg.src = scr.canvasImage()
            scrImg.onload = () => {
                // よりふちに近い画像が鏡面にあると考えて画像を書き出す
                if (info.paintedRect.x < canvasWidth - info.paintedRect.x - info.paintedRect.width) {
                    let offs = new OffScreen(canvasWidth - info.paintedRect.x * 2, info.paintedRect.height)
                    offs.drawTrimmingImage(scrImg, info.paintedRect.x, info.paintedRect.y, info.paintedRect.width, info.paintedRect.height, 0, 0, info.paintedRect.width, info.paintedRect.height)
                    self.ripuValue = Number((info.paintedRect.y * (self.canvasMiriMeterSize.width / self.canvasSize.width) / 10)).toFixed()
                    offs.toBlob((data) => {
                        if (!data) {
                            self.ripuValue = 0
                            let wk = new OffScreen(10, 10)
                            wk.toBlob((d) => {
                                resolve(d)
                            })
                        } else {
                            resolve(data)
                        }

                    })
                } else {
                    let newX = (canvasWidth - (info.paintedRect.x + info.paintedRect.width))
                    let offs = new OffScreen(canvasWidth - newX * 2, info.paintedRect.height)
                    offs.drawTrimmingImage(scrImg, info.paintedRect.x, info.paintedRect.y, info.paintedRect.width, info.paintedRect.height,
                        info.paintedRect.x - newX, 0, info.paintedRect.width, info.paintedRect.height)


                    self.ripuValue = Number((info.paintedRect.y * (self.canvasMiriMeterSize.width / self.canvasSize.width) / 10)).toFixed()
                    offs.toBlob((data) => {
                        if (!data) {
                            self.ripuValue = 0
                            let wk = new OffScreen(10, 10)
                            wk.toBlob((d) => {
                                resolve(d)
                            })
                        } else {
                            resolve(data)
                        }
                    })
                }
            }
        })
    }
    downloadImage() {
        let self = this
        let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
        this.itemList.forEach(function (item) {
            let hiritu = self.canvasSize.width / self.canvasScreenSize.width
            let posX = (item.posX + 10 - self.canvasScreenPosition.x) * hiritu
            let posY = (item.posY + 10 - self.canvasScreenPosition.y) * hiritu
            let width = item.imageWidth * hiritu
            let height = item.imageHeight * hiritu
            scr.drawImage(item.imageobj, posX, posY, width, height)
        })
        scr.downloadImage()

    }
    // 現在の情報をzipにする
    makeZipData() {

    }
    toJson() {
        var itemListJson = []
        this.itemList.forEach(function (item) {
            itemListJson.push(item.toJson())
        })
        return JSON.stringify({
            foregroundImagePath: this.foregroundImagePath,
            backgroundImagePath: this.backgroundImagePath,
            //cutlineImagePath: this.cutlineImagePath,
            canvasSize: this.canvasSize,
            canvasScreenSize: this.canvasScreenSize,
            canvasScreenPosition: this.canvasScreenPosition,
            canvasMiriMeterSize: this.canvasMiriMeterSize,
            ripuValue: this.ripuValue,
            itemList: itemListJson
        })
    }

    getProperty() {
        var itemListJson = []
        this.itemList.forEach(function (item) {
            itemListJson.push(item.getProperty())
        })

        return {
            foregroundImagePath: this.foregroundImagePath,
            backgroundImagePath: this.backgroundImagePath,
            //cutlineImagePath: this.cutlineImagePath,
            canvasSize: this.canvasSize,
            canvasScreenSize: this.canvasScreenSize,
            canvasScreenPosition: this.canvasScreenPosition,
            canvasMiriMeterSize: this.canvasMiriMeterSize,
            ripuValue: this.ripuValue,
            itemList: itemListJson
        }
    }
    /**
     * 履歴より復元
     * @param {} info 
     */
    async updateInfo(info, historyId, zipData) {
        this.ripuValue = info.ripuValue
        for (let item of info.itemList) {
            // let fileData = await zipData.file("" + historyId + "/" + item.itemId + ".png").async('blob')
            // await this.addItem(new File([fileData], item.itemId + ".png", { type: "image/png" }), item)
            console.log(zipData);
            console.log(item);
            //var newItem = null;
            switch(item.itemType){
                case "Image":
                    break;
                case "Text":
                    await this.addTextItem(item.textArray, item.font, item.align, item.color, item.itemName, item)
                    break;
                case "QR":
                    await this.addQRItem(item.textArray, item.color, item.bgColor, item.itemName, item)
                    break;
            }

            // if( newItem != null ){
            //     newItem.textArray = item.textArray;
            // }
        }
    }

    updateQuantity(num){
        for(let item of this.itemList){
            item.updateQuantity(num);
        }
    }

    createDesignBlob( callback = null ){
        return new Promise((resolove) => {
            let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
            // デザインイメージ
            scr.drawImage(this.designImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
            scr.toBlob(function (blob) {
                if( callback ){
                    callback(blob)
                }
                resolove(blob)
            })
        })
    }

    createCutlineBlob(){
        return new Promise((resolove) => {
            let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
            // デザインイメージ
            scr.drawImage(this.cutlineImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
            scr.toBlob(function (blob) {
                resolove(blob)
            })
        })
    }

    createDesignAndCutlineBlob( frameCutline ){
        return new Promise((resolove) => {
            let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
            // デザインイメージ
            scr.drawImage(this.designImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
            scr.drawImage(frameCutline, 0, 0, this.canvasSize.width, this.canvasSize.height)
            scr.toBlob(function (blob) {
                resolove(blob)
            })
        })
    }

    // アクリルの画像を生成
    // designとmonoを同時に生成
    async createAcrylImageBlob(itemIndex){
        const imageBlob = {};
        // 印刷の都合上、完成画像に余白を設ける
        // OffScreenがディープコピー出来ないためプレビュー用も生成
        let designScreen = new OffScreen(this.canvasSize.width, this.canvasSize.height)
        let previewScreen = new OffScreen(this.canvasSize.width, this.canvasSize.height)

        // デザインイメージ
        designScreen.drawImage(this.designImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
        previewScreen.drawImage(this.designImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
        for ( const item of this.itemList ){
            let hiritu = this.canvasSize.width / this.canvasScreenSize.width
            let imageBlob = null;
            let imageElement = null;

            switch(item.itemType){
                case "Image":
                    break;
                  case "Text":
                    imageBlob = await CreateTextImage(item.textArray[itemIndex], item.font, item.color, item.fontSize);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob = await RotateImage(imageElement, item.rotate, item.align);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob.width /= hiritu;
                    imageBlob.height /= hiritu;
                    break;
                  case "QR":
                    imageBlob = await CreateQRImage(item.textArray[itemIndex], item.color, item.bgColor);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob = await RotateImage(imageElement, item.rotate);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob.width /= hiritu;
                    imageBlob.height /= hiritu;
                    break;
            }

            // 比率をかけることで出力用テクスチャの座標系に変換
            let width = imageBlob.width * item.scale * hiritu
            let height = imageBlob.height * item.scale * hiritu
            let posX = item.posX * hiritu
            let posY = item.posY * hiritu

            // 描画用に原点をずらす
            posX -= width/2;
            posY -= height/2;

            designScreen.drawImage(imageElement, Math.floor(posX), Math.floor(posY), width, height)
            previewScreen.drawImage(imageElement, Math.floor(posX), Math.floor(posY), width, height)
        }

        // 最後に余白付きのものを生成する
        imageBlob.designImage = await new Promise(resolve => designScreen.toBlob(resolve));
        designScreen.monochrome();
        imageBlob.monoImage = await new Promise(resolve => designScreen.toBlob(resolve));

        // プレビュー用のイメージを生成
        previewScreen.drawImage(this.cutlineImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
        imageBlob.previewImage = await new Promise(resolve => previewScreen.toBlob(resolve));
        return imageBlob;
    }

    // 各テキストを反映したアクリル画像を生成する
    async createAcrylDesignBlob( itemIndex ){
        let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
        // デザインイメージ
        scr.drawImage(this.designImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
        for ( const item of this.itemList ){
            let hiritu = this.canvasSize.width / this.canvasScreenSize.width
            let imageBlob = null;
            let imageElement = null;

            switch(item.itemType){
                case "Image":
                    break;
                  case "Text":
                    imageBlob = await CreateTextImage(item.textArray[itemIndex], item.font, item.color);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob = await RotateImage(imageElement, item.rotate, item.align);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob.width /= hiritu;
                    imageBlob.height /= hiritu;
                    break;
                  case "QR":
                    imageBlob = await CreateQRImage(item.textArray[itemIndex], item.color, item.bgColor);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob = await RotateImage(imageElement, item.rotate);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob.width /= hiritu;
                    imageBlob.height /= hiritu;
                    break;
            }

            // 比率をかけることで出力用テクスチャの座標系に変換
            let width = imageBlob.width * item.scale * hiritu
            let height = imageBlob.height * item.scale * hiritu
            let posX = item.posX * hiritu
            let posY = item.posY * hiritu

            // 描画用に原点をずらす
            posX -= width/2;
            posY -= height/2;

            scr.drawImage(imageElement, posX, posY, width, height)
        }
        return await new Promise(resolve => scr.toBlob(resolve));
    }

    // 各テキストを反映したアクリル画像を生成する
    async createAcrylMonoBlob( itemIndex ){
        let scr = new OffScreen(this.canvasSize.width, this.canvasSize.height)
        // デザインイメージ
        scr.drawImage(this.designImageObj, 0, 0, this.canvasSize.width, this.canvasSize.height)
        for ( const item of this.itemList ){
            let hiritu = this.canvasSize.width / this.canvasScreenSize.width
            let imageBlob = null;
            let imageElement = null;

            switch(item.itemType){
                case "Image":
                    break;
                  case "Text":
                    imageBlob = await CreateTextImage(item.textArray[itemIndex], item.font, item.color);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob = await RotateImage(imageElement, item.rotate, item.align);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob.width /= hiritu;
                    imageBlob.height /= hiritu;
                    break;
                  case "QR":
                    imageBlob = await CreateQRImage(item.textArray[itemIndex], item.color, item.bgColor);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob = await RotateImage(imageElement, item.rotate);
                    imageElement = await CreateImageElement(URL.createObjectURL(imageBlob.blob));
                    imageBlob.width /= hiritu;
                    imageBlob.height /= hiritu;
                    break;
            }

            // 比率をかけることで出力用テクスチャの座標系に変換
            let width = imageBlob.width * item.scale * hiritu
            let height = imageBlob.height * item.scale * hiritu
            let posX = item.posX * hiritu
            let posY = item.posY * hiritu

            // 描画用に原点をずらす
            posX -= width/2;
            posY -= height/2;

            scr.drawImage(imageElement, posX, posY, width, height)
        }
        scr.monochrome()
        return await new Promise(resolve => scr.toBlob(resolve));
    }

}
export { CanvasData }